import { render, staticRenderFns } from "./serviceHeaderMobile.vue?vue&type=template&id=2f1d620a&scoped=true"
import script from "./serviceHeaderMobile.vue?vue&type=script&lang=js"
export * from "./serviceHeaderMobile.vue?vue&type=script&lang=js"
import style0 from "./serviceHeaderMobile.vue?vue&type=style&index=0&id=2f1d620a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d620a",
  null
  
)

export default component.exports